import React, { useContext, useEffect, useRef } from "react";
import { trackPosthog } from "../../../../../helper/tracking/tracking";
import { getAPIAxios } from "../../../../../helper/constants/uri";
import { usePaypalState } from "../../../../../zustand/payment/helper/paypalState";
import { AuthContext } from "../../../../../provider/authProvider";

declare var paypal: any;

const ShCheckoutBraintree = (
    {
        url = null,
        postData = { },

        paymentSucceeded = (resPaymentRequest: any) => { }
    }
) => {

    const authContext = useContext(AuthContext);
    const postDataRef = useRef<any>();

    useEffect(
        () => {
            postDataRef.current = postData;
        },
        [ postData ]
    );

    useEffect(
        () => {
            let client;
            let deviceData;

            const initClient = async () => {
                // already init
                if (client) {
                    return;
                }

                const axios = getAPIAxios();
                const res = await axios.get("/generateClientToken");
                const clientToken = res.data.clientToken;

                const brainTreeClient = (await import("braintree-web/client")).default;
                client = await brainTreeClient.create( { authorization: clientToken } );

                const brainTreeDataCollector = (await import("braintree-web/data-collector")).default;
                const dataCollector = await brainTreeDataCollector.create({
                    client,
                    paypal: true
                });

                deviceData = dataCollector.deviceData;
            }
            const action = async () => {
                try {
                    usePaypalState.getState().setIsPaypalLoading(true);

                    await initClient();

                    const brainTreePaypalCheckout = (await import('braintree-web/paypal-checkout')).default;
                    const braintreePaypalInstance = await brainTreePaypalCheckout.create( { client } );
                    await braintreePaypalInstance.loadPayPalSDK({ vault: true });

                    await paypal.Buttons({
                        fundingSource: paypal.FUNDING.PAYPAL,

                        createBillingAgreement: function () {
                            return braintreePaypalInstance.createPayment({ flow: 'vault' });
                        },

                        onApprove: (data, actions) => {
                            trackPosthog("paypal-on-approve", { data, actions } );

                            return braintreePaypalInstance.tokenizePayment(data, async (err, payload) => {
                                usePaypalState.getState().setIsPaypalPerforming(true);
                                trackPosthog("paypal-on-approve-tokenize-payment", { error: err, payload } );

                                try {
                                    const axios = getAPIAxios();

                                    const nonceHandlerResult = await axios.post(url, {
                                        ...postDataRef.current,
                                        nonce: payload.nonce,
                                        deviceData
                                    });

                                    await paymentSucceeded(nonceHandlerResult.data);
                                } catch(err) {
                                    trackPosthog("paypal-error", { error: err });
                                } finally {
                                    usePaypalState.getState().setIsPaypalPerforming(false);
                                }
                            });
                        },

                        onError: (err) => {
                            trackPosthog("paypal-on-error", { error: err });
                            authContext.updateOwnOverview();
                        }

                    }).render('#paypal-button');

                } catch(err) {

                    console.log('*** BRAINTREE Exception ');
                    console.log(err);

                    trackPosthog("paypal-error-finish", { error: err } );
                    authContext.updateOwnOverview();
                } finally {
                    usePaypalState.getState().setIsPaypalLoading(false);
                }

            };

            action();
        },
        []
    );

    return <div id="paypal-button" className={"mt-3 mb-2"} />
};

export default ShCheckoutBraintree;
